const SpecialCharType = {
  N41CODE: 'N41CODE',
  FILENAME: 'FILENAME',
  ALL: 'ALL'
}
const SearchType = {
  STYLE_NUMBER: 'STYLE_NUMBER',
  CATEGORY: 'CATEGORY',
  COLOR: 'COLOR',
  COLOR_SIZE: 'COLOR_SIZE',
  COLOR_SIZE_PRICE: 'COLOR_SIZE_PRICE',
  BARCODE: 'BARCODE'
}
export const e = {
  SpecialCharType,
  SearchType
}
